export default "__VITE_ASSET__C$70er6G__"